export const variants = {
  PRIMARY: 'primary',
  WARNING: 'warning',
  SECONDARY: 'secondary',
};
